import {userAppService, UserDto} from 'langyan';
import {preventDuplicateCall} from '@/lib/utils';
import {subscribeUserEvents} from './event-handlers';
import schoolApi from '@/api/school';
import userApi from '@/api/user';

export default {
  async initUserService({commit, state, rootState, dispatch}, payload) {
    subscribeUserEvents(commit, state, rootState, dispatch);

    await dispatch('loadContacts');
  },

  async loadContacts({commit, state, rootState, dispatch}) {
    let userDto = await userAppService.userOfId(rootState.userid);
    let contacts = {};
    userDto.contacts.forEach(c => contacts[c.id] = c);
    commit('updateContacts', contacts);
  },

  async toggleContactFavorite({commit, state, rootState, dispatch}, targetUser) {
    if (!targetUser || !targetUser.id || !targetUser.username) {
      throw new Error('addFavorite faild. invalid target user object.');
    }
    let userDto = new UserDto();
    userDto.id = targetUser.id;
    userDto.username = targetUser.username;
    if (targetUser.isFavorite === true) {
      await userAppService.removeContactFromFavoriteAsync(userDto);
      // await userAppService.removeContactAsync(userDto);
    } else {
      await userAppService.addContactAsync(userDto);
      await userAppService.addContactToFavoriteAsync(userDto);
    }
  },

  fetchUserByUsernameAsync({commit, state, rootState, dispatch}, payload) {
    let usernames = [];
    if (typeof payload === 'string') {
      usernames.push(payload);
    } else if (payload instanceof Array) {
      usernames = payload;
    }

    // exclude self
    usernames = usernames.filter(n => n !== rootState.profile.username);
    if (usernames.length === 0) {
      return;
    }

    usernames.forEach(username => {
      let user = state.users[username];
      if (user) {
        return;
      }

      preventDuplicateCall({id: `fetchUserByNameAsync-${username}`}, () => {
        userAppService.fetchUserByNameAsync(username);
      });
    });
  },

  async getSchools({commit, state, rootState, dispatch}, params) {
    let res = await schoolApi.getSchools(params);
    if (!res.success) {
      throw new Error('fail to query school list.');
    }
    return res.results;
  },

  async getStudentProfile({commit, state, rootState, dispatch}) {
    let res = await userApi.getStudentProfileById(rootState.userid);
    if (!res.success) {
      throw new Error('fail to query student profile');
    }
    return res.result;
  },

  async updateStudentProfile({commit, state, rootState, dispatch}, params) {
    params.userid = rootState.userid;
    let res = await userApi.updateStudentProfile(params);
    if (!res.success) {
      throw new Error('更新個人資料失敗');
    }
    let newProfile = res.data;
    commit('updateProfile', newProfile, {root: true});
  },

  getSchoolSystemNameByGrade({commit, state, rootState, dispatch}, grade) {
    if (!grade) {
      return '';
    }
    let schoolSystemId;
    if (grade < 7) {
      schoolSystemId = '5a43786d9a3a8503133ff100';
    } else if (this.grade <= 9) {
      schoolSystemId = '5a43788e9a3a8503133ff101';
    } else {
      schoolSystemId = '5a4378a19a3a8503133ff102';
    }
    return rootState.schoolSystems[schoolSystemId].tname;
  }
};